import Button from 'antd/lib/button'
import classNames from 'classnames'
import _JSXStyle from 'styled-jsx/style'
import ImageWithBasePath from './ImageWithBasePath'
export const PrimaryButton = ({
  id = '',
  title,
  onClick,
  disabled = false,
  loading = false,
  isSearchIconPresent = false,
  className = 'border-secondary bg-secondary',
  fullWidth = false,
  ...rest
}) => (
  <div
    id={id}
    direction="vertical"
    style={{
      position: 'relative',
    }}
    className={fullWidth && `w-full`}
  >
    <Button
      {...{
        disabled,
        onClick,
        loading,
        ...rest
      }}
      autoFocus={false}
      block
      className={classNames(
        'm-0 p-0 relative h-[40px] rounded-[4px] py-[7px] text-md font-bold leading-[25.6px] outline-none sm:text-base sm:leading-[19.7px]',
        !disabled ? 'border-xs text-black' : 'border-[0px] bg-[#E0E1E1] text-[#B1B1B4]',
        className,
        fullWidth && 'gap-[5px] flex justify-center items-center custom-height'
      )}
    >
      {isSearchIconPresent ? (
        <ImageWithBasePath
          className=" mb-[3px] mr-sm"
          src="searchIconNew"
          width={18}
          height={18}
          alt={'profile photo'}
        />
      ) : (
        ''
      )}
      {!loading ? title : ' '}
    </Button>
    <style jsx global>{`
      .ant-btn-default {
        border-width: 0px;
      }
    `}</style>
  </div>
)
